import React from 'react';
import Content from './Content';

const ContentPage: React.FC = () => {
    return (
        <>
            <Content />
        </>
    );
};

export default ContentPage;